import React, { useState } from 'react';

function RegisterForm() {
    const [form, setForm] = useState({
        LoginName: '',
        LoginSurname: '',
        LoginEmail: '',
        LoginPhoneNumber: '',
        LoginUsername: '',
        LoginPassword: ''
    });

    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const register = async () => {
        const res = await fetch('/api/auth/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        });

        if (res.ok) {
            setMessage("Registration successful! You can now log in.");
        } else {
            const err = await res.json();
            setMessage("Error: " + err.error);
        }
    };

    return (
        <div>
            <h2>Register</h2>
            <input name="LoginName" placeholder="Name" value={form.LoginName} onChange={handleChange} /><br />
            <input name="LoginSurname" placeholder="Surname" value={form.LoginSurname} onChange={handleChange} /><br />
            <input name="LoginEmail" type="email" placeholder="Email" value={form.LoginEmail} onChange={handleChange} /><br />
            <input name="LoginPhoneNumber" placeholder="Phone" value={form.LoginPhoneNumber} onChange={handleChange} /><br />
            <input name="LoginUsername" placeholder="Username" value={form.LoginUsername} onChange={handleChange} /><br />
            <input name="LoginPassword" type="password" placeholder="Password" value={form.LoginPassword} onChange={handleChange} /><br />
            <button onClick={register}>Register</button>
            <p>{message}</p>
        </div>
    );
}

export default RegisterForm;
